import script from "./SocialFundApplicantChat.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialFundApplicantChat.vue?vue&type=script&setup=true&lang=js"

import "./SocialFundApplicantChat.vue?vue&type=style&index=0&id=34bd7619&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34bd7619"]])

export default __exports__